import _debounce from 'lodash/debounce';

export function debounce(delay: number = 3000): MethodDecorator {
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    let timeout = null;

    const original = descriptor.value;

    descriptor.value = function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => original.apply(this, args), delay);
    };

    return descriptor;
  };
}

// https://engineering.datorama.com/be-aware-of-the-debounce-decorator-6fb24a6d8d5
export function debounceNext(milliseconds: number = 0, options = {}) {
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    const map = new WeakMap();
    const originalMethod = descriptor.value;
    descriptor.value = function (...params) {
      let debounced = map.get(this);
      if (!debounced) {
        debounced = _debounce(originalMethod, milliseconds, options).bind(this);
        map.set(this, debounced);
      }
      debounced(...params);
    };
    return descriptor;
  };
}
